const DEFAULT = '#00ac69';
const SECONDARY = '#A0D6AD';

const state = {
  logo: null,
  color: ''
};

const getters = {
  getLogo(state) {
    return state.logo;
  },
  getCustomURL(state) {
    return state.customURL;
  },
  getColor(state) {
    return state.color;
  },
  getPrimaryColor(state) {
    return state.color || DEFAULT;
  },
  getSecondaryColor() {
    return SECONDARY;
  },
  getDefault() {
    return DEFAULT;
  }
};

const mutations = {
  setBranding(state, data) {
    state.logo = data.logo || null;
    state.customURL = data.customURL || null;
    state.color = data.color || state.color;
  },
  reset(state) {
    state.logo = null;
    state.color = '';
    state.customURL = '';
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations
};
